export class CopyEncounterData {

      oldEncounterId: string;
      newEncounterId: string;
      allFlag: string;

      rosFlag: string;

      peFlag: string;

      cervicalFlag: string;
      thoracicFlag: string;
      lumbarFlag: string;

      hpiFlag: string;

      notes: string;

      createdBy: string;

      createdOn: Date;

      modifiedBy: string;

      modifiedOn: Date;

      isActive: boolean;

      dxFlag: string;

      procedureFlag: string;

      hxFlag: string;

      vitalFlag: string;

      ordersFlag: string;
      intakeFlag: string;
      discussionFlag: string;
      checkVitals?: string;
      patId?: number;
      IntakeFlag?: string;
}